import { App, Button, Space } from 'antd';
import React, { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

export function AppUpdate() {
  const appUpdateKey = 'app-update';
  const { notification } = App.useApp();

  // check for updates every hour
  const period = 60 * 60 * 1000;

  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, r) {
      if (period <= 0) return;
      if (r?.active?.state === 'activated') {
        registerPeriodicSync(period, swUrl, r);
      } else if (r?.installing) {
        r.installing.addEventListener('statechange', (e) => {
          const sw = e.target as ServiceWorker;
          if (sw.state === 'activated') registerPeriodicSync(period, swUrl, r);
        });
      }
    },
  });

  useEffect(() => {
    if (!needRefresh) return;
    // commit for trigge app update
    notification.open({
      message: 'A new version is available! ',
      description:
        'The updated content will be applied once all tabs for this page are closed. Click the button below to access the new version.',
      duration: 0, // never close, let the user decide
      closable: false,
      key: appUpdateKey,
      btn: (
        <Space>
          <Button
            size="small"
            onClick={() => {
              notification.destroy(appUpdateKey);
              setNeedRefresh(false);
            }}
          >
            Not now
          </Button>
          <Button
            type="primary"
            size="small"
            onClick={() => updateServiceWorker(true)}
          >
            Get new version
          </Button>
        </Space>
      ),
    });
  }, [needRefresh, notification, setNeedRefresh, updateServiceWorker]);

  return <div></div>;
}

/**
 * This function will register a periodic sync check every hour, you can modify the interval as needed.
 */
function registerPeriodicSync(
  period: number,
  swUrl: string,
  r: ServiceWorkerRegistration,
) {
  if (period <= 0) return;

  setInterval(async () => {
    if ('onLine' in navigator && !navigator.onLine) return;

    const resp = await fetch(swUrl, {
      cache: 'no-store',
      headers: {
        cache: 'no-store',
        'cache-control': 'no-cache',
      },
    });

    if (resp?.status === 200) await r.update();
  }, period);
}
